import { render, staticRenderFns } from "./UpcomingIposPage.vue?vue&type=template&id=131298d9&scoped=true&"
import script from "./UpcomingIposPage.vue?vue&type=script&lang=js&"
export * from "./UpcomingIposPage.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingIposPage.vue?vue&type=style&index=0&id=131298d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131298d9",
  null
  
)

export default component.exports